// src/components/kempower/AssetHeaderCard.jsx
import React from 'react';
import StatusPill from '../../../shared/components/pill/StatusPill';

export default function AssetHeaderCard({ stationName, lastUpdated, location, onlineStatus }) {
  const online = ['online', 'on'].includes(onlineStatus?.toLowerCase());

  return (
    <div className="card mb-3">
      <div className="card-body d-flex">
        {/* Icon for Charger */}
        <div style={{ fontSize: '2rem', marginRight: '1rem' }}>
          <i className="bi bi-lightning-charge-fill text-primary"></i>
        </div>
        <div>
          <h5 className="card-title mb-1">{stationName || 'Unnamed Charger'}</h5>
          <div className="text-muted" style={{ fontSize: '0.9rem' }}>
            Last updated: {lastUpdated || 'Unknown'}
          </div>
          <StatusPill tone={online ? 'success' : 'neutral'} size="touch" className="mt-2">
            {onlineStatus || 'offline'}
          </StatusPill>
          <div className="mt-2" style={{ fontSize: '0.9rem' }}>
            <i className="bi bi-geo-alt-fill me-1"></i>
            {location || 'Unknown Location'}
          </div>
        </div>
      </div>
    </div>
  );
}